export default __webpack_public_path__ + "static/media/saltstack.101c3d57.svg";